'use client'

import { Button } from '@snowball-tech/fractal/dist/src/components/Button'
import { UilQuestionCircle as InterrogationMarkCircleIcon } from '@tooni/iconscout-unicons-react'

import { useIntercom } from 'react-use-intercom'

import useTranslations from '../hooks/useTranslations'

type Props = {
  withLabel?: boolean
}
export default function IntercomButton({ withLabel = false }: Props) {
  const $t = useTranslations()

  const intercom = useIntercom()

  const handleHelpClick = () => {
    intercom.show()
  }

  return (
    <Button
      className="fixed bottom-2 right-2 lg:right-4 z-[48] print:hidden"
      icon={<InterrogationMarkCircleIcon />}
      iconOnly={!withLabel}
      iconPosition="left"
      label={$t('general.help')}
      variant="secondary"
      onClick={handleHelpClick}
    />
  )
}
